import "./App.css";
import ScrollToTop from "./Utils/ScrollToTop";
import Routes from "./Routes";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes />
    </>
  );
}

export default App;
